var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-close",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6845389,1.28552544 L29.5129661,4.11395257 L18.2056091,15.4205254 L29.5700518,26.669641 L26.7559776,29.5123486 L15.3776091,18.2485254 L4.05712195,29.5697967 L1.22869483,26.7413696 L12.5346091,15.4345254 L1.17160911,4.18568111 L3.98568328,1.3429735 L15.3636091,12.6055254 L26.6845389,1.28552544 Z",
    id: "icon-close"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ddd1897ded021225c99c41a213ce91cf.svg";
export { ForwardRef as ReactComponent };